import { createSlice } from "@reduxjs/toolkit";
import {
  fetchDepartmentsList,
  createOrUpdateDepartment,
  deleteDepartment,
} from "./departmentsThunks";

const departmentsSlice = createSlice({
  name: "departments",
  initialState: {
    departments: [],
    loading: false,
    error: null,
    successMessage: null,
    selectedDepartment: null,
    isEditDepartment: false,
  },
  reducers: {
    resetDepartmentManageStatus: (state) => {
      state.successMessage = null;
    },
    setSelectedDepartment: (state, action) => {
      state.selectedDepartment = action.payload;
    },
    setIsEditDepartment: (state, action) => {
      state.isEditDepartment = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDepartmentsList.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDepartmentsList.fulfilled, (state, action) => {
        state.loading = false;
        state.departments = action.payload;
      })
      .addCase(fetchDepartmentsList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createOrUpdateDepartment.fulfilled, (state, action) => {
        state.successMessage = action.payload.message;
      })
      .addCase(deleteDepartment.fulfilled, (state, action) => {
        state.successMessage = action.payload.message;
      });
  },
});

export const {
  resetDepartmentManageStatus,
  setSelectedDepartment,
  setIsEditDepartment,
} = departmentsSlice.actions;
export default departmentsSlice.reducer;
